/**
 * Search if the document element has the specified class.
 *
 * @param   {object}  element   - Element from document.
 * @param   {string}  className - Class to find inside className attribute from element.
 * @returns {boolean}           - True if element has the class given, false instead
 */
export function hasClass (element, className) {
  return (element.classList)
    ? element.classList.contains(className)
    : new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
}

/**
 * Add the class to the document element attribute className.
 *
 * @param   {object} element   - Element from document.
 * @param   {string} className - Class to add inside className attribute from element.
 * @returns {object}           - Element with class added.
 */
export function addClass (element, className) {
  if (element.classList)
    element.classList.add(className);
  else
    if (!hasClass(element, className)) element.className += ' ' + className;
}

/**
 * Remove the class to the document element attribute className.
 *
 * @param   {object} element   - Element from document.
 * @param   {string} className - Class to remove inside className attribute from element.
 * @returns {string}           - Element with class removed.
 */
export function removeClass (element, className) {
  if (element.classList)
    element.classList.remove(className);
  else
    if (hasClass(element, className)) element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
}

/**
 * Toggle the class of the document element attribute className.
 *
 * @param   {object} element   - Element from document.
 * @param   {string} className - Class to remove inside className attribute from element.
 * @returns {string}           - Element with class removed.
 */
export function toggleClass (element, className) {
  (hasClass(element, className))
    ? removeClass(element, className)
    : addClass(element, className);
}



// WEBPACK FOOTER //
// ./assets/javascripts/helpers/class_helper.js